module.exports = __webpack_public_path__ + "img/icons8-skoda.f49c586f.png";